import React, { useCallback, useContext, useMemo, useState } from 'react';
import style from './style';
import OrgChart from '../../../../components/common/charts/OrgChart';
import { Context } from '../../../../states/Store';
import EADialog from '../../../../components/common/EADialog';
import AddThirdParty from './AddThirdParty';
import Dialog from '@mui/material/Dialog';
import i18next from 'i18next';
import EAIcon from '../../../../components/common/EAIcon';
import EAColorIcon from '../../../../components/common/EAColorIcon';

const Visualisation = ({
  context,
  associatedTP,
  selectedTP,
  fetchContextInstance,
  fetchAssociatedTP,
}) => {
  const { classes } = style();
  const [state] = useContext(Context);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isAddTpDialogOpen, setIsAddTpDialogOpen] = useState(false);
  const [selectedNodeId, setSelectedNodeId] = useState(null);
  const [showArchived, setShowArchived] = useState(false);
  const filteredAssociatedTP = useMemo(
    () => associatedTP.filter(tp => showArchived || !tp.isArchived),
    [associatedTP, showArchived]
  );

  const parsedTree = (data, rootNodeName = 'rootNode', isContextArchived) => {
    const parsedData = data.map((node) => {
      let icon;
      if (node.origin === 'CLIENT' && node.parentId === -1) {
        icon = '/context/contextTree/standardTiers';
      } else if (node.origin === 'THIRDPARTY') {
        icon = '/context/contextTree/tiersTiers';
      } else if (node.origin === 'CLIENT_AND_THIRDPARTY') {
        icon = '/context/contextTree/clientTiersTiers';
      } else if (node.origin === 'CLIENT') {
        icon = '/context/contextTree/clientTiers';
      }
      return {
        label: node.name,
        identifiant: node.id,
        expanded: true,
        parentId: node.parentId,
        children: [],
        icon,
        origin: node.origin,
        isArchived: node.isArchived,
        isContextArchived,
      };
    });

    const nodeMap = {};
    parsedData.forEach((node) => {
      nodeMap[node.identifiant] = node;
    });

    const rootNode = [
      {
        label: rootNodeName,
        identifiant: 'root',
        expanded: true,
        children: [],
        icon: '/context/contextTree/root',
        isContextArchived
      },
    ];

    parsedData.forEach((node) => {
      if (node.parentId === -1) {
        rootNode[0].children.push(node);
      } else if (nodeMap[node.parentId]) {
        nodeMap[node.parentId].children.push(node);
      }
    });

    return rootNode;
  };

  const onClose = () => {
    setIsAddTpDialogOpen(false);
  };

  const toggleFullScreen = useCallback(() => {
    setIsFullScreen((prev) => !prev);
  }, []);

  if (isFullScreen) {
    return (
      <Dialog open={true} maxWidth={false} fullScreen onClose={() => {}}>
        <div className={classes.fullScreenContainer}>
          <div className={classes.fullScreenHeader}>
            <EAColorIcon icon={'/context/visualisation_block'} />
            <div className={classes.fullScreenHeaderTitle}>
              {i18next.t(
                `context.contextDetail.blocks.visualisation_fullscreen`
              )}
            </div>
            <div className={classes.fullScreenHeaderContextName}>
              {context.reference}
            </div>
            <EAIcon
              icon={'/cross'}
              className={classes.fullScreenHeaderClose}
              onClick={toggleFullScreen}
            />
          </div>
          <OrgChart
            tree={parsedTree(
              filteredAssociatedTP,
              state.account.name,
              context.isArchived
            )}
            selectedNodeId={selectedTP}
            setIsAddTpDialogOpen={(isOpen, selectedNodeId) => {
              setIsAddTpDialogOpen(isOpen);
              setSelectedNodeId(selectedNodeId);
            }}
            associatedTP={filteredAssociatedTP}
            fetchAssociatedTP={fetchAssociatedTP}
            fetchContextInstance={fetchContextInstance}
            toggleFullScreen={toggleFullScreen}
            isFullScreen={isFullScreen}
            setShowArchived={setShowArchived}
            showArchived={showArchived}
          />
        </div>
        <EADialog
          isOpen={isAddTpDialogOpen}
          onClose={onClose}
          displayBtn={false}
          crossVisible={true}
          maxWidth={'xl'}
        >
          <AddThirdParty
            context={context}
            parentId={selectedNodeId}
            setIsAddTpDialogOpen={(isOpen) => {
              setIsAddTpDialogOpen(isOpen);
              fetchContextInstance();
            }}
            associatedTP={associatedTP}
          />
        </EADialog>
      </Dialog>
    );
  }

  return (
    <div className={classes.root}>
      <OrgChart
        tree={parsedTree(
          filteredAssociatedTP,
          state.account.name,
          context.isArchived
        )}
        selectedNodeId={selectedTP}
        setIsAddTpDialogOpen={(isOpen, selectedNodeId) => {
          setIsAddTpDialogOpen(isOpen);
          setSelectedNodeId(selectedNodeId);
        }}
        associatedTP={filteredAssociatedTP}
        fetchAssociatedTP={fetchAssociatedTP}
        fetchContextInstance={fetchContextInstance}
        toggleFullScreen={toggleFullScreen}
        setShowArchived={setShowArchived}
        showArchived={showArchived}
      />
      <EADialog
        isOpen={isAddTpDialogOpen}
        onClose={onClose}
        displayBtn={false}
        crossVisible={true}
        maxWidth={'lg'}
      >
        <AddThirdParty
          context={context}
          parentId={selectedNodeId}
          setIsAddTpDialogOpen={(isOpen) => {
            setIsAddTpDialogOpen(isOpen);
            fetchContextInstance();
          }}
          associatedTP={associatedTP}
        />
      </EADialog>
    </div>
  );
};

export default Visualisation;
